import DialogActions from '@material-ui/core/DialogActions';
import {makeStyles} from '@material-ui/core/styles';
import React, {useContext} from 'react';

import {ModalContext} from 'components/modals/modal-context';
import {ButtonContext} from 'hooks/button-context';

import * as ModalConstants from 'components/modals/modal-constants';

import type {ButtonProps} from '@material-ui/core/Button';
import type {ReactNode} from 'react';

const useStyles = makeStyles(() => ({
    rootSmall: {
        padding: ModalConstants.modalMarginSm,
    },
    rootMedium: {
        padding: ModalConstants.modalMarginMd,
    },
    rootLarge: {
        padding: ModalConstants.modalMarginLg,
    },
}));

export type Props = {
    children: ReactNode;
};

const ModalActions = (props: Props) => {
    const {children} = props;
    const classes = useStyles();
    const {size, open} = useContext(ModalContext);
    const buttonSize: ButtonProps['size'] = size === 'small' ? 'small' : 'medium';

    let root: string;
    switch (size) {
        case 'small':
            root = classes.rootSmall;
            break;
        case 'large':
            root = classes.rootLarge;
            break;
        case 'medium':
        default:
            root = classes.rootMedium;
            break;
    }

    const buttonContextValue = {
        size: buttonSize,
        disabled: !open,
    };

    return (
        <ButtonContext.Provider value={buttonContextValue}>
            <DialogActions classes={{root}}>{children}</DialogActions>
        </ButtonContext.Provider>
    );
};

export default ModalActions;
